<template>
  <v-dialog
    v-model="dialog"
    persistent
    fullscreen
  >
    <template v-slot:activator="{ on: dialog }">
      <v-btn
        icon
        color="primary"
        v-on="{ ...dialog}"
      >
        <v-icon>
          mdi-eye
        </v-icon>
      </v-btn>
    </template>

    <v-container
      class="fill-height white-backgroud"    
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="7"
        >
          <v-card>
            <v-card-title class="white-color green-background">
              {{ exam.name }}  
            </v-card-title>
           
            <v-col cols="12">
              <span class="font-weight-bold">Name: </span>{{ attempt.employee.person.name }}
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <span class="font-weight-bold">Duration: </span>{{ attempt.duration?attempt.duration +' minute' :'Did not complete exam' }}
            </v-col>
            <v-col cols="12">
              <span class="font-weight-bold">Exam Taken On: </span>{{ $moment(attempt.created_at, 'YYYY-MM-DD HH:mm:ss').format('D MMM YYYY hh:mm A') }}
            </v-col>

            <v-divider />

            <v-col
              cols="12"
              class="scrollbar scroll-container"
            >
              <v-card
                v-for="(item,index) of attempt.exam_attempt_answers"
                :key="index"
              >
                <v-chip class="marks">
                  {{ item.mark }}% / {{ item.exam_question.mark }}%
                </v-chip>
               
                <v-card-title
                  class="pb-0"
                  v-html="item.exam_question.content"
                />
             
                <v-card-text
                  v-for="(answer,index) in item.exam_question.answer_choices"
                  :key="index"
                  class="py-0"
                >
                  <div v-if="item.exam_question.question_type_id === 1">
                    <div
                      :class="answerLabel(item,answer)"
                      class="px-1"
                    >
                      {{ String.fromCharCode(97 + answer.index).toUpperCase() }}.{{ answer.content }}
                    </div>
                  </div>

                  <div
                    v-if="item.exam_question.question_type_id === 2"
                    class="pb-4"
                  >
                    <span class="font-weight-bold">ANS:</span> {{ item.structure_answer }}
                    <div class="italic">
                      <span class="font-weight-bold color-dark">SUGGESTED ANS:</span> {{ answer.content }}
                    </div> 
                  </div>
                </v-card-text>
                <div
                  v-if="item.exam_question.question_type_id === 1"
                  class="px-4 pb-4 italic"
                >
                  <span class="font-weight-bold font-14">CORRECT ANS:</span> 
                  {{ String.fromCharCode(97 + item.exam_question.answer_choices[item.exam_question.answer_index].index).toUpperCase() }}.{{ item.exam_question.answer_choices[item.exam_question.answer_index].content }}
                </div>
              </v-card>
            </v-col>

            <v-divider />

            <v-col
              class="text-right"
              cols="12"
            >
              <v-spacer />
              <v-btn
                text
                @click="dialog = false"
              > 
                Cancel
              </v-btn>
            </v-col>
          </v-card>
        </v-col>
      </v-row> 
    </v-container>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      attempt: {
        type: Object,
        required: true,
      },
      exam: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
      }
    },

    methods: {
      answerLabel (item, answer) {
        return item.answer_index === answer.index ? item.answer_index === item.exam_question.answer_index ? 'correct-answer' : 'wrong-answer' : ''
      },
    },
  }
</script>

<style scoped>
.white-backgroud{
  background:white
}
.green-background{
  background:#5cb860;
}
.white-color{
  color:white;
}
.color-dark{
  color:#000000DE
}
.correct-answer{
  background-color: #ccffcc;
}
.wrong-answer{
  background-color: #ff9999;
}
.scrollbar::-webkit-scrollbar {
  width: 3px !important; 
}
.scrollbar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
.scrollbar::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}
.scrollbar::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}
.italic{
  font-style: italic;
}
.text-field-width{
  max-width:160px
}
.scroll-container{
  max-height:500px;
  overflow-y:scroll
}
.marks{
  position:absolute;
  right:16px;
  top:16px;
}
.font-14{
  font-size:14px;
}
.remove-spinner >>> ::-webkit-outer-spin-button,
.remove-spinner >>> ::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

</style>
